export enum PersistenceState {
  SAVED,
  SAVING,
  ERROR,
}
